<template lang="pug">
    v-stepper(v-model="el")
      v-stepper-header(ref="header")
        v-stepper-step( :complete="el>1" step="1") Review Cart
        v-divider
        v-stepper-step( :complete="el>2" step="2") Provide details
        v-divider
        v-stepper-step( step="3") Pay
        v-divider
      v-stepper-items
        v-stepper-content(step="1")
          div.display-1 Review your order
          cart(@next="nextStep")
        v-stepper-content(step="2")
          div.display-1 Lets get your details
          customer-details(:step="el" @next="nextStep")
        v-stepper-content(step="3")
          order-details
          cart(showCheckoutBtn="false" readonly="true")
          v-layout.text-xs-center(row)
            v-flex.py-3(xs12) You will be transferred to the WiPay portal at firstatlanticcommerce.com to complete secure payment
          form.text-xs-center(action="https://wipayfinancial.com/v1/gateway_live" method="post")
            input(name="total" type="hidden" :value="totalCost")
            input(name="phone" type="hidden" :value="$store.state.customer.phone")
            input(name="email" type="hidden" :value="$store.state.customer.email")
            input(name="name" type="hidden" :value="$store.state.customer.name")
            input(name="order_id" type="hidden" :value="$store.state.tempOrder.name")
            input(name="return_url" type="hidden" :value="returnURL")
            input(name="developer_id" type="hidden" value="1951")
            button.v-btn.theme--dark.green(type="submit" v-if="tempOrder != ''") Pay
       
</template>
<script>
import Cart from "./Cart"
import CustomerDetails from "../components/CustomerDetails"
import OrderDetails from "../components/OrderDetails"
export default {
  components:{Cart, CustomerDetails, OrderDetails},
  data:()=>({
    el:1,
    reason:''
    
  }),
  mounted(){
    this.$vuetify.goTo(this.$refs.header)
    this.$store.dispatch('clearTempOrders')
    console.log(this.canCheckout())
    if(this.canCheckout()){
      this.reason = ''
    }else{
      this.reason = 'Unable to checkout the selected event has already passed'
    }
  },
  computed:{
    totalCost(){
      let total = 0
      total+=this.convenienceFee
        this.$store.state.cart.packages.forEach(p=>{
          total += p.cost * p.amount
        })
        this.$store.state.cart.items.forEach(i=>{
          total += i.cost * i.amount
        })
      return total
    },
    convenienceFee(){
      return this.$store.state.convenienceFee
    },
    returnURL(){
      return 'https://www.rumrepublictt.com/order-success'
      //return 'http://localhost:8080/order-success'
    },
    tempOrder(){
      return this.$store.state.tempOrder
    }
  },
  methods:{
    nextStep(){
      this.$vuetify.goTo(this.$refs.header)
      this.el+=1
    },
    canCheckout(){
      if (this.$store.state.events){
        //return this.$store.state.events
        console.log("we have events")
        let that = this
        let events = this.$store.state.events
        let selectedEvent = this.$store.state.selectedEvent
        let event = null
        event = events.find(e=>{
          //console.log(e, selectedEvent === e.id)
          return selectedEvent === e.id
        })
        //console.log(events, selectedEvent, event)
        const [day, month, year] = event.eventDate.split('/')
        let d = `${month}/${day}/${year}`
        let eventDate = new Date(d)
        const [hours, mins] = event.startTime.split(':')
        // eventDate.setHours(hours,mins)
        console.log(event.eventName+": "+ hours +":"+mins, eventDate, d)
        return  eventDate > Date.now()      
      }else{
        //return true
      }
    }
  }
}
</script>

